import process from 'process/browser.js';
export { process };
